// extracted by mini-css-extract-plugin
export default {"reviewTodoIcon":"reviewStatusIcon_reviewTodoIcon__ZO+VD"};